var React = require('react');
var ReactNative = require('react-native');

var AppActions = require('./AppActions.js');
var LinkingManager = require('./wrappers/LinkingManager');
var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager');
var FadingView = require('./FadingView');
var FeedPlusView = require('./FeedPlusView');
var FeedPlusSideView = require('./FeedPlusSideView');
var OffsetView = require('./OffsetView');
var OverlayView = require('./Overlay');

const Icon = require('./wrappers/ReUpIcon');
var FEED_HEADER_HEIGHT = 80;

import Svg, {
    Path,
    G,
    Circle
} from './wrappers/react-native-svg-wrapper';

var Menu = require('./menu.js')
var FeedCard = require('./feedCard.js')
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpField = require('./ReUpField.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpCountdown = require('./ReUpCountdown');
var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');
var MapView = require('./wrappers/react-native-maps-wrapper');
var ReUpButton = require('./ReUpButton');
var Meter = require('./Meter.js');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
} = MK;

import ParallaxScrollView from './wrappers/react-native-parallax-scroll-view-wrapper';

var {
  View,
  Animated,
  ScrollView,
  StyleSheet,
  Platform,
  Image,
  TouchableHighlight,
  Dimensions,
  Keyboard,
  TouchableWithoutFeedback
} = ReactNative;

var FeedPlus = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    var feedPlusFeatures = this.props.appManager.getFeedPlusFeatures();
    var shouldAlwaysShowHeader = true;
    for( var i = 0; i < feedPlusFeatures.length; i++ )
    {
      if( feedPlusFeatures[i].key != "Login" && feedPlusFeatures[i].key != "CreateUser" )
      {
        shouldAlwaysShowHeader = false;
        break;
      }
    }

    return {
      menuOpen:false,
      rightOpen:false,
      cards:[],
      movePlusFront:true,
      shouldAlwaysShowHeader:shouldAlwaysShowHeader,
      tempHideLeft:false,
      tempHideRight:false,
    }
  },

  _context: 0,
  componentDidMount : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();

    if( this.refs.scrollView ) this.refs.scrollView.scrollTo({x:this.props.initialLayout.width})

    appActions._drawer = this;
    var height = 0;
    var width = 0;
    var didJigger = false;
    try {
      var {height, width} = Dimensions.get('window');

      if( height > 0 && width > 0 )
      {
        didJigger = true;
        setTimeout(()=>
        {
          if( thisThing.refs.scrollView && Platform.OS == "ios" ) thisThing.refs.scrollView.scrollTo({x:width-1});
          if( thisThing.refs.scrollView ) thisThing.refs.scrollView.scrollTo({x:width});
        },1)
      }
    } catch (e) {

    } finally {

    }

    if( !didJigger )
    {
      setTimeout(()=>
      {
        if( thisThing.refs.scrollView )
        {
          if( thisThing.refs.scrollView && Platform.OS == "ios" ) thisThing.refs.scrollView.scrollTo({x:thisThing.props.initialLayout.width-1});
          if( thisThing.refs.scrollView ) thisThing.refs.scrollView.scrollTo({x:thisThing.props.initialLayout.width});
        }
      },1)
    }

    appManager.loginCallBackStart = function()
    {
      appActions.requestPop(false);
      appActions.setSpinnerShown(true, "Logging in...");
      appManager.getCurrentUser(function(a)
      {
        thisThing.checkUserChanged();
      })
    }
    appManager.loginCallBackFinish = function()
    {
      appActions.requestPop(false);
      appActions.setSpinnerShown(false);
      appManager.getCurrentUser(function(a)
      {
        thisThing.checkUserChanged();
      })
    }

    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);

    var appActions = this.props.appActions;
    var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
    var {dataDependencies, customDependencies} = this.props.dataDependencyRetriever(feedFeatureNames);

    this.doUpdate();
  },

  componentWillUnmount : function()
  {
    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
  },

  doUpdate: function()
  {
    this._shouldUpdateOnScroll = false;
    this._shouldUpdateOnScrollAfterGoingDown = false;

    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
    var {dataDependencies, customDependencies} = this.props.dataDependencyRetriever(feedFeatureNames);

    var hasRewards = false;
    for( var i = 0; i < dataDependencies.length; i++ )
    {
      if( dataDependencies[i] == "Rewards" )
      {
        hasRewards = true;
      }
    }
    if( !hasRewards ) dataDependencies.push("Rewards");

    appManager.getDataTypes(thisThing.props.allDependencyKeys, function(data)
    {
      thisThing.didUpdate(data)
    })

    NetworkManager.update(appManager, dataDependencies, function(newData)
    {
      if( customDependencies.length <= 0 )
      {
        thisThing._shouldUpdateOnScrollAfterGoingDown = true;
        appManager.setData(newData,()=>
        {
          thisThing.didUpdate(newData)
        })
      }
      else
      {
        NetworkManager.retrieveCustomDataDependencies(appManager, customDependencies, newData, function(totalData)
        {
          thisThing._shouldUpdateOnScrollAfterGoingDown = true;
          appManager.setData(totalData,()=>
          {
            thisThing.didUpdate(totalData)
          })
        });
      }
    }, function(){thisThing._shouldUpdateOnScrollAfterGoingDown = true;});
  },

  open: function()
  {
    this.props.appActions._navigator.overrideMenuOpen = true;
    this.setHorizontalScrollerOffset(0);
  },

  setHorizontalScrollerOffset: function(offset)
  {
    if( Platform.OS == 'web' )
    {
      var thisThing = this;
      var x = new Animated.Value(this._menuScrollOffsetX);
      x.addListener(({value})=>
      {
        if( thisThing.refs.scrollView ) thisThing.refs.scrollView.scrollTo({x:value, animated:false});
      });
      Animated.timing(x,
      {
        toValue:offset,
        duration:200
      }).start()
    }
    else
    {
      if( this.refs.scrollView ) this.refs.scrollView.scrollTo({x:offset, animated:true});
      setTimeout(()=>
      {
        this.props.appActions._navigator.forceUpdate();
      }, 50)
    }
  },

  close: function()
  {
    this.props.appActions._navigator.overrideMenuOpen = false;
    this.setHorizontalScrollerOffset(this.props.initialLayout.width);
  },

  toggle: function()
  {
    if( this.state.menuOpen ) this.close();
    else this.open();
  },

  _loggedInRendered : null,
  _oldPoints : null,
  _oldDollars : null,
  checkUserChanged : function()
  {
    var appManager = this.props.appManager;
    var loggedIn = this.props.appManager.isLoggedIn();
    if( loggedIn != this._loggedInRendered )
    {
      this._loggedInRendered = loggedIn;
      if( !this._loggedInRendered )
      {
        this.didUpdate({});
        this.scrollMiddle();
        this.scrollDown();
      }
      this.doUpdate();
    }

    if( loggedIn )
    {
      if( this._feedPlusView ) this._feedPlusView.setPoints(appManager.currentUser()[ModelConstants.Points]);
      if( this._oldPoints != appManager.currentUser()[ModelConstants.Points] ||
          this._oldDollars != appManager.currentUser()[ModelConstants.Credits] )
      {
        this.forceUpdate();
      }

      var thisThing = this;
      thisThing.props.appManager.getSelfie(function(selfieURL)
      {
        if( selfieURL != thisThing.state.selfieURL ) thisThing.setState({selfieURL});
      })
    }
  },

  didUpdate : function(data)
  {
    var thisThing = this;
    thisThing._cardUpdateTimeout = null;
    var feedFeatureNames = thisThing.props.appManager.getFeedFeatureNames();
    var feedFeatures = thisThing.props.appManager.getFeedFeatures();
    if( typeof data !== 'undefined' && typeof data.Rewards !== 'undefined' && data.Rewards.length > 0 )
    {
      if( thisThing._feedPlusView ) thisThing._feedPlusView.setRewards(data.Rewards)
    }
    else
    {
      thisThing.props.appManager.getDataType("Rewards",function(rewards)
      {
        if( typeof rewards !== 'undefined' )
        {
         if( thisThing._feedPlusView ) thisThing._feedPlusView.setRewards(rewards)
        }
      })
    }

    thisThing.props.appManager.getDataTypes(thisThing.props.allDependencyKeys,function(data)
    {
      if( typeof data !== 'undefined' )
      {
       var cards = thisThing.props.getCards(feedFeatureNames, thisThing.props.appManager, thisThing.props.appActions, data, feedFeatures);
        thisThing.props.appManager.getSelfie(function(selfieURL)
        {
          thisThing.setState({selfieURL:selfieURL, cards:cards});
        })
      }
    })
  },

  scrollUp : function()
  {
    if( this._feedScrollContainer ) this._feedScrollContainer.scrollTo({y:this.props.initialLayout.height})
  },

  scrollDown : function()
  {
    if( this._feedScrollContainer ) this._feedScrollContainer.scrollTo({y:0})
  },

  scrollMiddle : function()
  {
    if( this.refs.scrollView ) this.refs.scrollView.scrollTo({x:this.props.initialLayout.width})
  },

  renderFeedHeader: function()
  {
    var loggedIn = this.props.appManager.isLoggedIn();

    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", 0.2);

    var useCreditFeature = this.props.appManager.getFeatureForName("UseCredit");
    var creditIconName = typeof useCreditFeature === 'undefined' ? "" : useCreditFeature.data.icon.replace("fa-", "");
    var useCreditIsInFeed =  typeof useCreditFeature === 'undefined' ? false : useCreditFeature.data.shouldShowInFeed;

    var rewardsFeature = this.props.appManager.getFeatureForName("Rewards")
    var rewardsIconName = typeof rewardsFeature === 'undefined' ? "" : rewardsFeature.data.icon.replace("fa-", "");
    var rewardsIsInFeed =  typeof rewardsFeature === 'undefined' ? false : rewardsFeature.data.shouldShowInFeed;

    var creditPercentage = 0;
    var pointPercentage = 0;
    var creditString = "";
    var pointsString = "";
    var initials = "";

    if( loggedIn )
    {
      initials = appManager.currentUserInitials();
      var maxDollars = parseFloat(appManager.getLocalizationManager().getConstants()["CREDITS_FOR_MAX"]);
      var maxPoints = parseFloat(appManager.getLocalizationManager().getConstants()["TOTAL_POINTS_FOR_REWARD"]);
      var currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
      var currPoints = parseFloat(appManager.currentUser()[ModelConstants.Points]);
      creditString = appManager.getLocalizationManager().localizedDollars(currDollars);
      pointsString = appManager.getLocalizationManager().localizedPts(currPoints);
      creditPercentage = parseFloat(currDollars / maxDollars);
      pointPercentage = parseFloat(currPoints / maxPoints);
    }

    var leftTextStyle = {backgroundColor:'transparent',margin:0,marginTop:0, marginLeft:2, width:FEED_HEADER_HEIGHT - 16 - 4, height:FEED_HEADER_HEIGHT - 16 - 4,borderRadius:(FEED_HEADER_HEIGHT - 16 - 4)/2, justifyContent:'center', alignItems:'center'};

    return (
      <Animated.View style={[styles.feedHeader, {backgroundColor:profileColor}]}>
        <View style={styles.feedHeaderLeftContainer}>
          <TouchableHighlight
            underlayColor={"transparent"}
            activeOpacity={0.9}
            onPress={()=>{ appActions.requestFeatureName("Settings")}}>
              <View style={[styles.profileImage, {borderColor:'transparent', backgroundColor:profileColor, backgroundColor:'transparent', borderWidth:0}]}>
              {
                !loggedIn ?
                <View style={leftTextStyle}>
                  <Icon name={"lock"} size={48} color={profileImageColor} />
                </View>
                :
                typeof this.state.selfieURL !== 'undefined' && this.state.selfieURL != null && this.state.selfieURL.length > 0 ?

                <View>
                  <ReUpText appManager={appManager} style={[styles.profileImageText, {color: profileImageColor, position: 'absolute', top:13, left:0, right: 0, bottom: 0 }]}>
                    {initials}
                  </ReUpText>
                  <Image source={{uri: this.state.selfieURL}} style={leftTextStyle}>
                  </Image>
                </View>
                :
                <View style={leftTextStyle}>
                  <View><ReUpText appManager={appManager} style={[styles.profileImageText, {color:profileImageColor}]}>
                    {initials}
                  </ReUpText></View>
                </View>
              }
              <Svg
                height={FEED_HEADER_HEIGHT}
                width={FEED_HEADER_HEIGHT}
                style={{position:'absolute', top:-12,left:-12, backgroundColor:'transparent'}}
              >
                  <G scale="1">
                    <Circle cx={(FEED_HEADER_HEIGHT + 8)/2} cy={(FEED_HEADER_HEIGHT + 8)/2} r={(FEED_HEADER_HEIGHT - 16 - 4)/2} stroke={profileImageColor} stroke-width="2" fill={'transparent'} />
                  </G>
              </Svg>
            </View>
          </TouchableHighlight>
        </View>
        {
          loggedIn ?
          <View style={[styles.feedHeaderCenterContainer]}>
            <View />
            {
              useCreditIsInFeed ?
              <MKButton onPress={() => appActions.requestFeatureName("AddCredit")}>
                <Meter height={FEED_HEADER_HEIGHT/3} initialPercent={creditPercentage} innerColor={profileMeterColor} outerColor={profileMeterBackgroundColor}>
                  <Icon name={creditIconName} size={FEED_HEADER_HEIGHT/5} color={profileIconColor} style={{backgroundColor:'transparent'}} />
                </Meter>
              </MKButton> : null
            }
            {
              rewardsIsInFeed ?
              <MKButton onPress={() => appActions.requestFeatureName("Rewards")}>
                <Meter height={FEED_HEADER_HEIGHT/3} initialPercent={pointPercentage} innerColor={profileMeterColor} outerColor={profileMeterBackgroundColor}>
                  <Icon name={rewardsIconName} size={FEED_HEADER_HEIGHT/5} color={profileIconColor} style={{backgroundColor:'transparent', alignSelf:'center'}} />
                </Meter>
              </MKButton> : null
            }
            <View />
          </View>
          :
          <View style={styles.feedHeaderCenterContainer}>
            <View />
            <View><ReUpText isTitle={true} appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.feedHeaderInfo, {color:profileTitleColor}]}>
              {locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")}
            </ReUpText></View>
            <View />
          </View>
        }

        {
          loggedIn ?
          <View style={styles.feedHeaderRightContainer}>
            <View />
            {
              useCreditIsInFeed ?
              <MKButton onPress={() => appActions.requestFeatureName("AddCredit")} style={{height:FEED_HEADER_HEIGHT/3, alignItems:'center', flexDirection:'row'}}>
                <View><ReUpText appManager={appManager} isTitle={true} style={[styles.feedHeaderInfo, {color:profileTitleColor}]}>
                  {creditString}
                </ReUpText></View>
              </MKButton>: null
            }
            {
              rewardsIsInFeed ?
              <MKButton onPress={() => appActions.requestFeatureName("Rewards")} style={{height:FEED_HEADER_HEIGHT/3, alignItems:'center', flexDirection:'row'}}>
                <View><ReUpText appManager={appManager} isTitle={true} style={[styles.feedHeaderInfo, {color:profileTitleColor}]}>
                  {pointsString}
                </ReUpText></View>
              </MKButton>: null
            }
            <View />
          </View>
          :
          <View  />
        }
      </Animated.View>
    )

  },

  _leftRightBlur : 0,
  _upDownBlur : 0,
  _shouldUpdateOnScroll: false,
  _shouldUpdateOnScrollAfterGoingDown: true,
  _shouldCenterHorizonalScroll: false,
  render: function()
  {
    // return <View style={{width:100, height:100, backgroundColor:'red'}} />
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var cardColor = appManager.getColorForKey("FeedCardColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
    if( profileMeterBackgroundColor == generalColor ) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor",0.4);
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");

    var bgImage = this.props.appManager.absoluteResourceForPath("Feed" + '/background.png');

    // link is expired, instruct user to register again or w/e
    var overlayView = null;
    if( appManager.expiredLink() )
    {
      overlayView = (<OverlayView style={[styles.container, addedContainerStyle, {alignItems:'stretch', justifyContent:'center', flexDirection:'column', backgroundColor:generalColor}]}>
        <BlurView ref="blurView" blurType="light" initialOpacity={0} style={{position:'absolute', left:0, right:0, top:0, bottom:0}} imageName={bgImage} imageKey={appManager.getImageKey("bg")} />
        <View style={{padding:20, margin:12, backgroundColor:generalColor, borderRadius:4, flexDirection:'column'}}>
          <View style={{marginBottom:8, flex:-1}}>
            <ReUpText isTitle={true} appManager={appManager} style={{color:generalTitleColor, textAlign:'center'}}>
            {locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE")}
            </ReUpText>
          </View>
          <View style={{flex:-1}}>
            <ReUpText appManager={appManager} style={{color:generalTitleColor, textAlign:'center'}}>
            {locManager.localizedStringForKey("EXPIRED_LINK_ERROR_STATEMENT")}
            </ReUpText>
          </View>
        </View>
      </OverlayView>)
    }
    else if( appManager.needsRegistration() )
    {
      var registrationFeatureData = this.props.appManager.getFeatureForName("SimpleCreateUser")
      var registrationFeature = this.props.featureBuilder.featureForData(registrationFeatureData, this.props.initialLayout, appManager, {shouldHideActionBar:true, didCompleteRegistration:()=>
      {
        appManager._needsRegistration = false;
        thisThing.setState({didRegister:true});
      }});
      overlayView = (
        <OverlayView style={[{alignItems:'stretch', justifyContent:'center', flexDirection:'column', backgroundColor:generalColor}]}>
        {registrationFeature}
        </OverlayView>
      )
    }
    else if( appManager.needsCFD() )
    {
      var simpleCFDFeatureData = this.props.appManager.getFeatureForName("SimpleCFD");
      var simpleCFDFeature = this.props.featureBuilder.featureForData(simpleCFDFeatureData, this.props.initialLayout, appManager, {shouldHideActionBar:true});
      overlayView = (
        <OverlayView style={[{alignItems:'stretch', justifyContent:'center', flexDirection:'column', backgroundColor:generalColor}]}>
        {simpleCFDFeature}
        </OverlayView>
      )
    }

    var headerPath = appManager.absoluteResourceForPath('Feed'+'/'+'header.png');
    var menuOpenThreshold = (this.state.tempHideLeft ? -1 : 1)*this.props.initialLayout.width/2;
    var rightOpenThreshold = (this.state.tempHideLeft ? 1 : 3)*this.props.initialLayout.width/2;

    var topRightFeatures = appManager.getTopRightFeatures();
    var shouldShowTopRightFeature = topRightFeatures.length > 0 && (!topRightFeatures[0].data.requiresLogin || appManager.isLoggedIn())
    var rightFeature = null;
    var topRightText = null;
    if( shouldShowTopRightFeature )
    {
      var isLivePay = appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.PayMode] == 1;
      if( topRightFeatures[0].key == "UseCredit" || topRightFeatures[0].key == "EarnPay" )
      {
        if( isLivePay )
        {
          topRightText = topRightFeatures[0].data.shortTitle;
        }
        else
        {
          var currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
          // TODO:remove
          if( appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com" )
          {
            currDollars = 12.75;
          }
          topRightText = appManager.getLocalizationManager().localizedDollars(currDollars);
        }
      }
      var rightLayout = {width:this.props.initialLayout.width-40, height:(this.props.initialLayout.height-(Globals.ACTION_BAR_HEIGHT+12) - 20)};
      rightFeature = this.props.featureBuilder.featureForData(topRightFeatures[0], rightLayout, appManager, {shouldHideActionBar:true, borderRadius:10});
      // rightFeature = this.props.featureBuilder.featureForData(appManager.getFeatureForName("EarnPay"), rightLayout, appManager, {shouldHideActionBar:true});
    }
    // TODO: remove this
    // rightFeature = this.props.featureBuilder.featureForData(appManager.getFeatureForName("EarnPay"), this.props.initialLayout, appManager, {shouldHideActionBar:true})

    var shouldShowHeaderImageOnFeedPlus = false;

    var shouldAlwaysShowHeader = this.state.shouldAlwaysShowHeader;

    var addedContainerStyle = {backgroundColor:generalColor, position:'absolute', left:0, right:0, top:0, bottom:0};
    var height = 0;
    var width = 0;
    try {
      var {height, width} = Dimensions.get('window');

      if( height > 0 && width > 0 )
      {
        if( Platform.OS !== 'ios' ) height -= Globals.STATUS_BAR_HEIGHT; // status bar
        addedContainerStyle = {width,height, backgroundColor:generalColor}
      }
    } catch (e) {

    } finally {

    }

    var HorizontalScrollClass = Platform.OS == 'web' ? OffsetView : ScrollView;
    var showTopBar = appManager.showTopBar();

    var mainView = <View style={{flex:1, backgroundColor:'transparent', width:this.props.initialLayout.width}}>
      <ScrollView key={(a)=>this._feedScrollContainer} ref="feedScrollContainer"
        bounces={false}
        keyboardShouldPersistTaps="handled"
        snapToInterval={this.props.initialLayout.height- (shouldAlwaysShowHeader ? FEED_HEADER_HEIGHT : 0)}
        decelerationRate={"fast"}
        scrollEventThrottle={20}
        scrollEnabled={true}
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
        style={{alignSelf:"stretch", flex:1, width:this.props.initialLayout.width, height:this.props.initialLayout.height}} onScroll={(info)=>
        {
          if( thisThing._shouldCenterHorizonalScroll && thisThing.refs.scrollView ) thisThing.refs.scrollView.scrollTo({x:this.props.initialLayout.width});
          thisThing._upDownBlur = info.nativeEvent.contentOffset.y / (thisThing.props.initialLayout.height - Globals.ACTION_BAR_HEIGHT);
          if( thisThing._upDownBlur < .75 ) thisThing._shouldScrollOuterUp = true;
          thisThing.refs.blurView.setOpacity(Math.max(thisThing._leftRightBlur, thisThing._upDownBlur));
          if( !shouldAlwaysShowHeader ) thisThing.refs.fadingView.setOpacity(thisThing._upDownBlur);
          if( Platform.OS === 'ios' || Platform.OS === 'web' )
          {
            if( thisThing._feedPlusView ) thisThing._feedPlusView.setZoomOut(thisThing._upDownBlur <= 0 ? thisThing._upDownBlur : thisThing._upDownBlur*2);
            // thisThing._feedPlusViewBack.setZoomOut(thisThing._upDownBlur);
              var plusEnabled = thisThing._upDownBlur > .5 ;
            if( thisThing._feedPlusView ) thisThing._feedPlusView.setEnabled(!plusEnabled);
          }

          if( info.nativeEvent.contentOffset.y >= (thisThing.props.initialLayout.height - Globals.ACTION_BAR_HEIGHT) && thisThing._shouldUpdateOnScrollAfterGoingDown )
          {
            thisThing._shouldUpdateOnScroll = true;
          }

          if( thisThing._shouldUpdateOnScroll && info.nativeEvent.contentOffset.y <= 0 ) thisThing.doUpdate();
        }}
      >
        <View style={{flexDirection:'row'}}>
          {
            appManager.disableFeed() ?
              <View style={{height:this.props.initialLayout.height - (shouldAlwaysShowHeader ? (2*FEED_HEADER_HEIGHT - Globals.STATUS_BAR_HEIGHT) : 0), width:0}} />
            :
              <View style={{height:this.props.initialLayout.height*2 - (shouldAlwaysShowHeader ? (2*FEED_HEADER_HEIGHT - Globals.STATUS_BAR_HEIGHT) : 0), width:0}} />
          }
          <View style={{flex:1, flexDirection:'column'}}>
            <View style={{height:this.props.initialLayout.height - (shouldAlwaysShowHeader ? (2*FEED_HEADER_HEIGHT - Globals.STATUS_BAR_HEIGHT) : 0), width:this.props.initialLayout.width}}>
            {
              Platform.OS !== 'ios' ?
                <FeedPlusView key={"feedPlusView"+thisThing.props.appManager._featureVersion} ref={(a)=>this._feedPlusView = a}
                  initialLayout={this.props.initialLayout}
                  style={{position:'absolute', top:showTopBar ? Globals.ACTION_BAR_HEIGHT : 0, left:0, right:0, bottom:0}}
                  upArrowSelected={()=>{thisThing.scrollUp()}}
                  appManager={appManager} appActions={appActions}  />
              : <View style={{flex:1}} />
            }
            </View>
            {
              !appManager.disableFeed() ?
                <View style={{flexDirection:'column'}}>
                <View style={{height:showTopBar ? Globals.ACTION_BAR_HEIGHT : 0}} />
                {
                  Platform.OS === 'ios' ?
                    <ScrollView
                      pagingEnabled={false}
                      bounces={true}
                      keyboardShouldPersistTaps="handled"
                      showsHorizontalScrollIndicator={false} showsVerticalScrollIndicator={false}
                      style={{width:this.props.initialLayout.width, height:this.props.initialLayout.height-(showTopBar ? Globals.ACTION_BAR_HEIGHT : 0)}}
                      scrollEventThrottle={20}
                      onScroll={(info)=>
                      {
                        if( thisThing._shouldScrollOuterUp && info.nativeEvent.contentOffset.y < -200)
                        {
                          thisThing._shouldScrollOuterUp = false;
                          thisThing.scrollDown();
                        }
                      }}>
                      <View style={{flex:1, paddingBottom:4, marginTop:shouldAlwaysShowHeader ? FEED_HEADER_HEIGHT : 0, width:this.props.initialLayout.width}}>
                        {
                          this.state.cards.map(function(card,index)
                          {
                            return (
                              <FeedCard {...card}
                                      key={card.key}
                                      appManager={appManager}
                                      iconColor={bannerIconColor}
                                      bannerColor={bannerColor}
                                      cardColor={cardColor}
                                      titleColor={titleColor}
                                      bodyColor={bodyColor}
                                      rippleColor={rippleColor}
                                      cardHeight={(height) =>
                                        {
                                        }
                                      }/>
                            )
                          })
                        }
                      </View>
                    </ScrollView>
                  :
                    <View style={{flex:1, paddingBottom:4, marginTop:shouldAlwaysShowHeader ? FEED_HEADER_HEIGHT : 0, width:this.props.initialLayout.width}}>
                      {
                        this.state.cards.map(function(card,index)
                        {
                          return (
                            <FeedCard {...card}
                                    key={JSON.stringify(card)}
                                    appManager={appManager}
                                    iconColor={bannerIconColor}
                                    bannerColor={bannerColor}
                                    cardColor={cardColor}
                                    titleColor={titleColor}
                                    bodyColor={bodyColor}
                                    rippleColor={rippleColor}
                                    cardHeight={(height) =>
                                      {
                                      }
                                    }/>
                          )
                        })
                      }
                    </View>
                }
                </View>
              : null
            }
            {
              shouldAlwaysShowHeader ?
                <View style={{position:'absolute', height:FEED_HEADER_HEIGHT, left:0, right:0, top:this.props.initialLayout.height-FEED_HEADER_HEIGHT}}>
                {
                  thisThing.renderFeedHeader()
                }
                </View>
              : null
            }
          </View>
        </View>
      </ScrollView>
      {
        Platform.OS === 'ios' ?
          <FeedPlusView key="feedPlusView" ref={(a)=>this._feedPlusView = a}
            initialLayout={this.props.initialLayout}
            style={{position:'absolute', top:showTopBar ? Globals.ACTION_BAR_HEIGHT : 0, left:0, right:0, bottom:0}}
            upArrowSelected={()=>{thisThing.scrollUp()}}
            appManager={appManager} appActions={appActions}  />
        : null
      }
    </View>;
    if( !showTopBar )
    {
      return <View style={[styles.container, addedContainerStyle]}>
        <BlurView ref="blurView" blurType="light" initialOpacity={0} style={{position:'absolute', left:0, right:0, top:0, bottom:0}} imageName={bgImage} imageKey={appManager.getImageKey("bg")} />
        {mainView}
        {overlayView}
      </View>
    }

    return(
      <View style={[styles.container, addedContainerStyle]}>
        <BlurView ref="blurView" blurType="light" initialOpacity={0} style={{position:'absolute', left:0, right:0, top:0, bottom:0}} imageName={bgImage} imageKey={appManager.getImageKey("bg")} />
        <HorizontalScrollClass ref="scrollView" keyboardShouldPersistTaps="handled" showsHorizontalScrollIndicator={false} showsVerticalScrollIndicator={false} decelerationRate={"fast"} scrollEventThrottle={20} onScroll={(info)=>
          {
            var scrollOffsetX = info.nativeEvent.contentOffset.x;
            thisThing._menuScrollOffsetX = scrollOffsetX;
            var width = thisThing.props.initialLayout.width;
            thisThing._shouldCenterHorizonalScroll = Platform.OS === 'web' && scrollOffsetX != width;

            if( Platform.OS === 'ios' || Platform.OS === 'web' )
            {
              var menuOpen = menuOpenThreshold > scrollOffsetX;
              if( thisThing.state.menuOpen != menuOpen )
              {
                thisThing.setState({menuOpen});
                thisThing.props.appActions._navigator.overrideMenuOpen = menuOpen;
                setTimeout(()=>
                {
                  thisThing.props.appActions._navigator.forceUpdate();
                }, 50)
              }

              var rightOpen = rightOpenThreshold < scrollOffsetX;
              if( thisThing.state.rightOpen != rightOpen ) thisThing.setState({rightOpen});

              thisThing._leftRightBlur = Math.abs(parseFloat(scrollOffsetX + (thisThing.state.tempHideLeft ? width : 0) - width)/width);
              thisThing.refs.blurView.setOpacity(Math.max(thisThing._leftRightBlur, thisThing._upDownBlur));
              if( thisThing.refs.leftSideView && scrollOffsetX < width ) thisThing.refs.leftSideView.setAmountIn(thisThing._leftRightBlur);
              if( thisThing.refs.rightSideView && scrollOffsetX > width ) thisThing.refs.rightSideView.setAmountIn(thisThing._leftRightBlur);
              if( scrollOffsetX <= 0 && !thisThing.state.tempHideRight ) thisThing.setState({tempHideRight:true});
              if( scrollOffsetX >= width && thisThing.state.tempHideRight ) thisThing.setState({tempHideRight:false});
              // if( scrollOffsetX >= 2*width && !thisThing.state.tempHideLeft ) thisThing.setState({tempHideLeft:true});
              // if( scrollOffsetX <= 0 && thisThing.state.tempHideLeft )
              // {
              //   thisThing.setState({tempHideLeft:false});
              //   thisThing.refs.scrollView.scrollTo({x:width, animated:false})
              // }
              if( typeof thisThing._lastScrollOffsetX !== 'undefined' )
              {
                thisThing._lastScrollOffsetXDelta = scrollOffsetX - thisThing._lastScrollOffsetX;
              }
              thisThing._lastScrollOffsetX = scrollOffsetX;
            }
            else
            {
              var menuOpen = menuOpenThreshold > scrollOffsetX;
              if( thisThing.state.menuOpen != menuOpen ) thisThing.setState({menuOpen});

              var rightOpen = rightOpenThreshold < scrollOffsetX;
              if( thisThing.state.rightOpen != rightOpen ) thisThing.setState({rightOpen});

              thisThing._leftRightBlur = Math.abs(parseFloat(info.nativeEvent.contentOffset.x - thisThing.props.initialLayout.width)/thisThing.props.initialLayout.width);
              thisThing.refs.blurView.setOpacity(Math.max(thisThing._leftRightBlur, thisThing._upDownBlur));
              thisThing.refs.leftSideView.setAmountIn(1);
              if( thisThing.refs.rightSideView ) thisThing.refs.rightSideView.setAmountIn(1);
            }
          }}
          onScrollEndDrag={()=>
          {
            if( Platform.OS == 'ios' || Platform.OS === 'web' )
            {
              var width = thisThing.props.initialLayout.width;
              if( !thisThing.state.tempHideRight && thisThing._lastScrollOffsetX < width  && thisThing._lastScrollOffsetXDelta > 0 )
              {
                thisThing.refs.scrollView.scrollTo({x:width})
              }
              if( !thisThing.state.tempHideLeft && thisThing._lastScrollOffsetX > width  && thisThing._lastScrollOffsetXDelta < 0 )
              {
                thisThing.refs.scrollView.scrollTo({x:width})
              }
            }
          }}
          removeClippedSubviews={true} bounces={false} horizontal={true} pagingEnabled={Platform.OS !== 'ios'} snapToInterval={this.props.initialLayout.width} style={[{flex:1, alignSelf:'stretch'}]}>
          <View style={{flex:-1, height:this.props.initialLayout.height, flexDirection:'row', alignItems:'stretch'}}>
            {
              !this.state.tempHideLeft ?
                <FeedPlusSideView ref="leftSideView" style={{flex:1, backgroundColor:'transparent', width:this.props.initialLayout.width}}>
                  <View style={{marginTop:Globals.ACTION_BAR_HEIGHT+12, marginBottom:20, marginHorizontal:20, flex:1}}>
                    <View clipToSubviews={true} style={{overflow:'hidden', flex:1, borderRadius:10}}>
                      <Menu key="menu" ref="menu"
                        menuFeatures={this.props.appManager.getMenuFeatures()}
                        menuTitleColor={appManager.getColorForKey("MenuTitleColor")}
                        menuIconColor={appManager.getColorForKey("MenuIconColor")}
                        menuHighlightColor={appManager.getColorForKey("MenuSelectionColor")}
                        menuBackgroundColor={appManager.getColorForKey("MenuColor")}
                        menuSeparatorColor={appManager.getColorForKey("MenuIconColor",0.4)}
                        AppActions={this.props.appActions}
                        appManager={appManager}
                        appActions={appActions}
                        layout={this.props.initialLayout}
                        style={{borderTopRightRadius:20, borderBottomRightRadius:20, borderTopLeftRadius:20, borderBottomLeftRadius:20}}
                        />
                    </View>
                  </View>
                </FeedPlusSideView>
              : null
            }
            {mainView}
            {
              rightFeature && !this.state.tempHideRight ?
                <FeedPlusSideView ref="rightSideView" style={{flex:1, backgroundColor:'transparent', width:this.props.initialLayout.width}}>
                  <View style={{marginTop:Globals.ACTION_BAR_HEIGHT+12, marginBottom:20, marginHorizontal:20, flex:1}}>
                    <View clipToSubviews={true} style={{overflow:'hidden', flex:1, borderRadius:10}}>
                    {
                      rightFeature
                    }
                    </View>
                  </View>
                </FeedPlusSideView>
              : null
            }
          </View>
        </HorizontalScrollClass>
        <FadingView ref="fadingView"
          style={{position:'absolute', alignItems:'flex-end', flexDirection:'row', top:0, left:0, right:0, height:Globals.ACTION_BAR_HEIGHT, backgroundColor:headerColor}}
          initialOpacity={shouldAlwaysShowHeader ? 1 : 0}>
          <TouchableWithoutFeedback onPress={()=>{thisThing.props.appActions._navigator.showDebugIfEnoughTouches((new Date()).getTime())}}>
            <View style={[{flex:1, marginHorizontal:50, alignItems:'center'}, Globals.TOP_CENTER_ADJUSTMENT]}>
              <Image key={appManager.getImageKey("header")} style={{
                height:44,
                width:150,
                padding:0,
                flex:-1,
              }} resizeMode={"stretch"} source={{uri: headerPath}}/>
            </View>
          </TouchableWithoutFeedback>
        </FadingView>
        <View onStartShouldSetResponder={(evt) => {if( evt.nativeEvent.identifier == 2 || (Platform.OS != "ios" && evt.nativeEvent.identifier == 1)) this.props.appActions._navigator.showDebugIfEnoughTouches(evt.nativeEvent.timestamp)}}
         style={[{
             alignItems:'stretch',
             justifyContent:'center',
             height:Globals.ACTION_BAR_HEIGHT - Globals.STATUS_BAR_HEIGHT,
             position:'absolute',
             top:Globals.STATUS_BAR_HEIGHT,
             left:0,
             right:0,
             flexDirection:'row',
           }]}>
          {
            showTopBar ?
              <View style={[{width:50}, Globals.TOP_LEFT_STYLE_ADJUSTMENT]}>
                {
                  !thisThing.state.rightOpen ?
                    <View><ReUpIconButton key={this.state.menuOpen ? "times" : "bars"}
                      iconName={this.state.menuOpen ? "times" : "bars"}
                      appManager={appManager}
                      buttonColorOverride={headerColor}
                      type={2}
                      accessibilityLabel={locManager.localizedStringForKey("MENU_ACCESSIBILITY_BUTTON")}
                      onPress={()=>
                      {
                        thisThing.toggle();
                      }}/></View>
                  : null
                }
              </View>
            : null
          }
          <View style={[{flex:1, alignItems:'center'}, Globals.TOP_CENTER_ADJUSTMENT]}>
          {
            false && (shouldShowHeaderImageOnFeedPlus || shouldAlwaysShowHeader) ?
              <Image key={appManager.getImageKey("header")} style={{
                height:44,
                width:150,
                padding:0,
                flex:-1,
              }} resizeMode={"stretch"} source={{uri: headerPath}}/>
            : null
          }
          </View>
          {
            showTopBar ?
              <View style={[Globals.TOP_RIGHT_STYLE_ADJUSTMENT]}>
               {
                 topRightText != null && !this.state.rightOpen && !this.state.menuOpen ?
                   <View>
                     <MKButton onPress={()=>
                       {
                         thisThing.setHorizontalScrollerOffset(thisThing.state.rightOpen ? thisThing.props.initialLayout.width : 2*thisThing.props.initialLayout.width)
                       }}
                       backgroundColor={'transparent'}
                       shadowRadius={0}
                       shadowOffset={{width:0, height:0}}
                       shadowOpacity={0}
                       shadowColor={'transparent'}
                       style={[{height:36, borderRadius:18, margin:4, backgroundColor:'transparent'}]}
                       maskBorderRadius={22}
                       rippleColor={appManager.getColorForKey("HeaderIconColor", .2)}>
                       <View style={[{height:36, borderRadius:18, paddingHorizontal:8, alignItems:'center', justifyContent:'center', backgroundColor:headerColor}]}>
                         <View style={{flex:-1}}>
                           <ReUpText isTitle={true} appManager={appManager} style={{color:headerIconColor}}>
                           {topRightText}
                           </ReUpText>
                         </View>
                       </View>
                     </MKButton>
                   </View>
                 : null
               }
               {
                 (topRightText == null || this.state.rightOpen) && shouldShowTopRightFeature && !this.state.menuOpen ?
                   <View>
                     <ReUpIconButton key={this.state.rightOpen ? "times" : topRightFeatures[0].data.icon.replace("fa-", "")}
                       iconName={this.state.rightOpen ? "times" : topRightFeatures[0].data.icon.replace("fa-", "")}
                       appManager={appManager}
                       buttonColorOverride={headerColor}
                       type={2}
                       style={{marginRight:Platform.OS != 'web' ? 12 : 4}}
                       accessibilityLabel={locManager.localizedStringForKey("TOPRIGHT_ACCESSIBILITY_BUTTON")}
                       onPress={()=>
                       {
                         thisThing.setHorizontalScrollerOffset(thisThing.state.rightOpen ? thisThing.props.initialLayout.width : 2*thisThing.props.initialLayout.width)
                       }}/>
                   </View>
                 : null
               }

              </View>
            : null
          }
        </View>
        {overlayView}
      </View>
    )
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
    backgroundColor:'red'
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  feedHeader: {
    height:FEED_HEADER_HEIGHT,
    flexDirection:'row'
  },
  feedHeaderLeftContainer: {
    padding:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    alignItems:'center',
    justifyContent:'center',
  },
  profileImage: {
    height:FEED_HEADER_HEIGHT - 16,
    width:FEED_HEADER_HEIGHT - 16,
    borderRadius:(FEED_HEADER_HEIGHT - 16)/2,
    borderWidth:2,
    borderColor:'black',
    justifyContent:'center',
  },
  profileImageText: {
    textAlign:'center',
    fontSize:(FEED_HEADER_HEIGHT - 20)/2,
    fontWeight:'bold',
    backgroundColor:'transparent'
  },
  feedHeaderCenterContainer: {
    height:FEED_HEADER_HEIGHT,
    paddingVertical:10,
    flex:1,
    justifyContent:'space-between',
  },

  feedHeaderRightContainer: {
    paddingVertical:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    justifyContent:'space-between',
    alignItems:'center',
  },
  feedHeaderInfo: {
    fontWeight:'bold'
  },
})
FeedPlus.dataDependencies = ["Users", "Rewards"];

module.exports = FeedPlus;



// WEBPACK FOOTER //
// ./src/FeedPlus.js